/* uf-growth-events.js - Ultrafood behavioural events for Hotjar/Contentsquare,
   fanned out to GA4 / Meta / Clarity / TikTok when those tags are present.
   Events queue into _uxa/hj stubs and are only transmitted if the consent-gated
   tag loads (analytics consent given). No PII captured; email inputs suppressed. */
(function () {
  'use strict';
  var once = {};
  function track(name, onlyOnce) {
    if (onlyOnce && once[name]) return;
    once[name] = 1;
    try {
      window._uxa = window._uxa || [];
      window._uxa.push(['trackPageEvent', name]);
      if (typeof window.hj === 'function') window.hj('event', name);
      if (typeof window.gtag === 'function') window.gtag('event', name);
      if (typeof window.clarity === 'function') window.clarity('event', name);
      if (typeof window.fbq === 'function') window.fbq('trackCustom', name);
      if (window.ttq && typeof window.ttq.track === 'function') window.ttq.track(name);
    } catch (e) { /* never break the page */ }
  }

  /* --- click-based intent events (delegated, capture phase) --- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-plans] .plan[data-kind="sub"]')) track('plan_subscription_selected');
    else if (t.closest('[data-plans] .plan[data-kind="one"]')) track('plan_onetime_selected');
    else if (t.closest('[data-facts-open]')) track('ingredients_opened', true);
    else if (t.closest('.faqs summary')) track('faq_opened', true);
    else if (t.closest('#ufpop-claim, #ufpop-form [type="submit"], #ufpop-s1 .ufpop-pillb')) track('offer_engaged', true);
    else if (t.closest('a[href*="/checkout"], button[name="checkout"], a[href^="/discount/"]')) track('begin_checkout_clicked');
    else if (t.closest('sup, [id^="claim-"]')) track('evidence_opened', true);
  }, { capture: true, passive: true });

  /* --- add to cart (cart/add form submit) --- */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && f.action.indexOf('/cart/add') > -1) {
      var sp = f.querySelector('[data-selling-plan], [name="selling_plan"]');
      track('add_to_cart');
      track(sp && sp.value ? 'add_to_cart_subscription' : 'add_to_cart_onetime');
    }
  }, true);

  /* --- passive proof exposure (viewed, not clicked) --- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { track(en.target.getAttribute('data-uf-evt'), true); io.unobserve(en.target); }
      });
    }, { threshold: 0.4 });
    [
      ['[id*="uf4-results"], [class*="results-quartet"], [class*="results-panel"]', 'reviews_viewed'],
      ['[id*="claims-index"], [class*="claims-index"]', 'evidence_viewed']
    ].forEach(function (v) {
      var el = document.querySelector(v[0]);
      if (el) { el.setAttribute('data-uf-evt', v[1]); io.observe(el); }
    });
  }

  /* --- PDP 50% scroll marker (powers "saw less than half of PDP" segment) --- */
  if (location.pathname.indexOf('/products/') === 0) {
    var fired = false;
    window.addEventListener('scroll', function () {
      if (fired) return;
      var h = document.documentElement;
      if ((window.scrollY + window.innerHeight) / h.scrollHeight >= 0.5) {
        fired = true;
        track('pdp_scrolled_50', true);
      }
    }, { passive: true });
  }

  /* --- launch popup funnel (piñata) + offer banner --- */
  (function () {
    var seen = false, hits = 0, pollId = null;
    function checkOpen() {
      var ov = document.getElementById('ufpop-ov');
      if (ov && !ov.hidden && !seen) {
        seen = true;
        track('popup_viewed', true);
        if (pollId) { clearInterval(pollId); pollId = null; }
      }
    }
    if ('MutationObserver' in window) {
      new MutationObserver(checkOpen).observe(document.documentElement,
        { attributes: true, subtree: true, attributeFilter: ['hidden'] });
    }
    pollId = setInterval(checkOpen, 1500);
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('#ufpop-game')) { hits++; track(hits === 1 ? 'popup_hit_1' : 'popup_burst', true); }
      else if (t.closest('#ufpop-x')) track('popup_dismissed', true);
      else if (t.closest('#ufpop-claim')) track('popup_pill_reopened', true);
      else if (t.closest('#ufbn')) track('banner_offer_clicked', true);
    }, { capture: true, passive: true });
    document.addEventListener('submit', function (e) {
      if (e.target && e.target.id === 'ufpop-form') track('popup_email_submitted', true);
    }, true);
  })();

  /* --- privacy: suppress email inputs from session recordings --- */
  function suppress() {
    document.querySelectorAll('input[type="email"]').forEach(function (i) {
      i.setAttribute('data-hj-suppress', '');
      i.setAttribute('data-cs-mask', '');
    });
  }
  if (document.readyState !== 'loading') suppress();
  else document.addEventListener('DOMContentLoaded', suppress);
})();